// @ts-nocheck
import BecomeADistributorState from "@store/Framework/Store/Bunzl/Components/BecomeADistributorForm/BecomeADistributorState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialState: BecomeADistributorState = {
    isLoading: false,
};

const actions = {
    "Bunzl/Components/BecomeADistributor/BeginLoading": (draft: Draft<BecomeADistributorState>) => {
        draft.isLoading = true;
    },
    "Bunzl/Components/BecomeADistributor/FinishLoading": (draft: Draft<BecomeADistributorState>) => {
        draft.isLoading = false;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type BunzlComponentsBecomeADistributorFormActions = Parameters<typeof reducer>[1];
export default reducer;
